export enum InvoiceType {
  PERSON = 'PERSON',
  COMPANY = 'COMPANY'
}
